<template>
  <div>
    <img :src="thumburl.replace('.resized.{bucket}', '')"  class="card-img-top audio-funny-img"/>
    <audio controls class="audio-controls-funny">
      <source :src="audiourl">
    </audio>
  </div>
</template>

<style lang="scss">
  .audio-funny-img {
    object-fit: cover;
    height: 240px;
    width: 240px;
    margin: 40px 40px 0 40px;
    display: flex;
    align-items: center;
  }
  .audio-controls-funny {
    float: left;
    z-index: 1;
    width: 240px;
    margin: 0px 0px 0px 40px;
  }
</style>

<script>
export default {
  name: 'single-funny-voice',
  props: ['audiourl', 'thumburl']
}
</script>



// WEBPACK FOOTER //
// src/components/previews/SingleFunnyVoice.vue